export default __webpack_public_path__ + "static/media/I10751.bd64f228.jpg";